module.exports = __webpack_public_path__ + "media/images/bnr_special_traditional-3bac462039a9a44bf9b752aedcf1274a.jpg";